// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4u-0";
export var eligibilityCardNotEligible = "_4u-1";